import e from "express";
import DATE from "../../UTIL/DATE";
import RANDOM from "../../UTIL/RANDOM";
import CONQUER from "../CONQUER";
import User from "../USER/User";
import AltStorage from './AltStorage';

class Storage
{

    private conquer: CONQUER;
    private canAccessLocalStorage:boolean;
    private altStorage:AltStorage;

    private get storage()
    {
        if (this.canAccessLocalStorage) return window.localStorage;
        else return this.altStorage;
    }

    public constructor( instance:CONQUER) {
        this.conquer = instance;
        this.canAccessLocalStorage = true;
        this.altStorage = new AltStorage();
    }
    /*=============== 


    INIT
    

    ================*/ 
 
    public async init( ): Promise<any> 
    {

        // this.setAccount( this.conquer.User );
        // this.setAccount( this.loadAccount() );
        // this.setAccount( this.parseUrlSearchParams() );

        // console.log('storage initialized!');
        
        // check if local storage is available by checking cookie
        if (typeof window != 'undefined' && !navigator.cookieEnabled)
        {
            this.canAccessLocalStorage = false;
            console.log('use altStorage');
        } 
        else
        {
            console.log('use localStorage');
        }

        return Promise.resolve();
    }

    private generateUsername()
    {
        return "Guest_" + DATE.now() + RANDOM.value(1000);
    }

    private loadAccount()
    {
        let oldUsername = typeof this.conquer.User != 'undefined' ? this.conquer.User.username : null;
        let type = typeof this.conquer.User != 'undefined' ? this.conquer.User.type : null;
        console.log(`[Conquer Storage] loadAccount oldUsername: ${JSON.stringify(oldUsername)}`);
        let json = typeof window != 'undefined' ? this.storage.getItem( "account" ) : null;
        console.log(`[Conquer Storage] loadAccount json 1: ${JSON.stringify(json)}`);
        if (json == 'null' || json == '{}') json = null;
        console.log(`[Conquer Storage] loadAccount json 2: ${JSON.stringify(json)}`);
        var user:User = json ? 
            JSON.parse( json as string ) : 
            {
                username: oldUsername == null ? this.generateUsername() : oldUsername,
                type: type == null ? "GUEST" : type,
            };

        console.log(`[Conquer Storage] loadAccount user: ${JSON.stringify(user)}`);
        return user;
    }
 
    private parseUrlSearchParams()
    {

        let originalParams:{[key:string]:any} = { };
        let params : any = {};

        if ( typeof window == 'undefined' ) return null;
        
        new URL( window.location.href ).searchParams.forEach((val, key) => 
        {
            if (User.Fields.indexOf(key) >= 0) {
                
                if( params[key] !== undefined ) 
                {
                    if ( !Array.isArray(params[key]) ) params[key] = [params[key]];

                    params[key].push(val);
                } else {
                    params[key] = val;
                }
            } else {
                originalParams[key] = val;
            }
        });

        // console.log(`window.location.href`, window.location.href);

        // console.log(`params`, params);
        
        let originalSearchParams:string = Object.keys(originalParams).map(key => key + '=' + originalParams[key]).join('&');
        let originalUrl = window.location.href.substring(0, window.location.href.indexOf('?')) + `${originalSearchParams.length > 0 ? "?" + originalSearchParams : ""}`;
    
        window.history.pushState( params, "", `${originalUrl}`);
 
        return params.username ? params : null;
    }


    /*=============== 


    GET
    

    ================*/

    public get( key:string ) : any
    {	
   		return typeof window != 'undefined' ? this.storage.getItem( key ) : null;
    }
 
    /*=============== 


    SET
    

    ================*/

    public set( key:string, value:any ) 
    {
        if( typeof window != 'undefined' ) {
            if (value == null) {
                this.storage.removeItem(key);
            } else {
                let safeValue = typeof value == 'string' ? value : JSON.stringify( value );
                this.storage.setItem( key, safeValue );
            }
        }
        return value;
    }

    /*=============== 


    REMOVE
    

    ================*/

    public remove( key:any ) 
    {
        this.set( key, null );
    }

    public removeAccount() 
    {
        this.remove( "account" );
        // this.setAccount( this.loadAccount() );
    }
 
}

namespace Storage 
{

}

export default Storage;